import React, { useState } from "react"
import Button from "@kit/design/button"
import Card from "@kit/design/card"
import { calloutMap } from "app/navigation/utils/callout-map"
import PlanComparison from "../shared/components/plan-comparison"

const handleCelebration = () => {
  analytics.track(
    "Element",
    "Clicked",
    {
      element_type: "button",
      name: "learn_more_upgrade_callout",
      text: "Learn more"
    },
    { transport: "beacon" }
  )

  window.location.reload()
}

export function MobileCtaNav({ userInfo }) {
  const [
    showCallout,
    calloutLink,
    calloutContent,
    openPlanComparison,
    planComparisonModalContent
  ] = calloutMap(userInfo)
  const [showPlanComparison, setShowPlanComparison] = useState(false)

  const handleClick = e => {
    if (openPlanComparison) {
      e.preventDefault()
      setShowPlanComparison(true)
    }
  }

  return (
    <React.Fragment>
      {showCallout && (
        <div className="bg-white p-3">
          <Card className="bg-blue-50">
            <h2 className="pb-2 font-semibold">{calloutContent["header"]}</h2>

            <div className="mb-5 text-gray-800 whitespace-pre-wrap">
              {calloutContent["text"]}
            </div>

            <Button is="primary" href={calloutLink} onClick={handleClick}>
              {calloutContent["buttonText"]}
            </Button>
          </Card>
        </div>
      )}
      {showPlanComparison && (
        <PlanComparison
          title={planComparisonModalContent["title"]}
          description={planComparisonModalContent["description"]}
          serviceLevels={planComparisonModalContent["plans"]}
          onClose={() => setShowPlanComparison(false)}
          afterCelebration={handleCelebration}
          prioritizedServiceLevel={
            planComparisonModalContent["prioritizedPlan"]
          }
        />
      )}
    </React.Fragment>
  )
}
